import type { CommonStylesPalette } from '../types.d';

export const inputFieldStyle = ({ palette = {} as CommonStylesPalette, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  // Checkbox and radio style begin
  'input[type="checkbox"], input[type="radio"]': {
    outline: 'none',
    appearance: 'none',
    '-webkit-appearance': 'none',
    '-moz-appearance': 'none',
  },

  'input[type="checkbox"]': {
    fontFamily: iconFontFamily,

    '&:after': {
      content: '"\\E73E"',
    },
  },

  '.checkbox-inline, .checkbox>label, .radio-inline, .radio>label, label.checkbox, label.radio': {
    padding: [8, 5, 8, 28],
    left: -8,
    position: 'relative',

    '&:focus-within': {
      outline: `1px solid ${palette.neutralSecondary}`,
    },

    '& input[type="checkbox"]': {
      marginTop: 3,

      '&:focus': {
        outline: 'none',
      },
    },
  },
  // Checkbox and radio style end

  // Text style begin
  'input[type="text"]': {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',

    '&:hover': {
      border: `1px solid ${palette.neutralPrimary}`,
    },

    '&:focus': {
      border: `1px solid ${palette.themePrimary}`,
    },
  },
  // Text style end
});
